import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Column, Row, cls } from '../../packages/components';
import SeasonsNumber from './components/SeasonsNumber';
import EpisodesList from './components/EpisodesList';
import * as api from '../../requests/loader';
import { setMetricsEvent } from '../../actions/metrics';
import AnalyticsDimensionSingleton from '../Header/AnalyticsDimensionSingleton';
import { playFullMedia } from '../../actions/playmedia';
import EventEmitter from '../../utils/EventEmitter';
import { AAF_MODAL_ERROR, MODAL_PURCHASE_SERIE, showModal, MODAL_KEEP_WATCHING } from '../../actions/modal';
import Translator from '../../requests/apa/Translator';
import { ColoredButton } from '../../packages/components/lib/ColoredButton/';
import Device from '../../devices/device';
import LayersControl from '../../utils/LayersControl';
import store from './../../store';
import {DOES_NOT_APPLY} from '../../utils/trackers/GA4Constants';
import {getContentCategory, getContentAvailability, getSeasonEpisodeInfo} from '../../utils/Utils';
import logger from 'src/utils/logger/logger';

class EpisodesManager extends Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            episodeNumber: 0,
            seasonNumber: 0,
            seasons: [],
            episodes: [],
            bookmark: [],
            pbi: [],
            isBookmarkUpdateOrPBIUpdate: false
        };
        this.keys = Device.getDevice().getKeys();
        this.titleBack = Translator.get('title_close_modal_episodes', 'CERRAR');
        this.group_id = this.props  && this.props.group_id || null;
    }

    componentDidMount = () => {
        this.addClassToParent();
        this.init();
        this.addListener();
    };

    componentWillUnmount = () => {
        this.removeListener();
    }

    addListener = () => {
        document && document.addEventListener('keydown', this.handleKey, true);
    }

    removeListener = () => {
        document && document.removeEventListener('keydown', this.handleKey, true);
    }


    handleKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'YELLOW':
                e.preventDefault();
                e.stopPropagation();
                this.handleBack();
            break;
            default:
        }
    }

    addClassToParent = () => {
        const x = document.getElementById('modal-overlay-main');
        if (x && x.classList && typeof x.classList.add === 'function') {
            x.classList.add('modal-overlay-episodes');
        }
    };

    isAnonymous = () => this.props && this.props.user && this.props.user.isAnonymous;

    onClick = async (episode) =>{
        this.props && (typeof this.props.handleClose ==='function');
        // FUNCION ES SIMILAR A
        const groupId = episode.id;
        if(this.group_id == groupId) return;
        const pbi = await api.purchaseButtonInfo(groupId);
        const wasPurchased = pbi && pbi.playButton && pbi.playButton.waspurchased;
        const payway_token = pbi && pbi.playButton && pbi.playButton.payway_token;
        if (wasPurchased) {
            EventEmitter.emit('player:episodeChange', { groupId });
            if(this.props && (typeof this.props.changeContentfromSelector === 'function')){
                this.group_id = groupId;
                this.props.handleClose();
                return this.props.changeContentfromSelector(groupId, payway_token);
            }
        } else {
            this.showPurchaseSerieModal(episode, pbi);
        }
    }

    stop = () => {
        if (LayersControl.isPlayerVisible()) {
          LayersControl.hidePlayer(true);
        }
        const nullPlayer = {
          ispip: false,
          islive: false,
          ispreview: false,
          playerstate: 'STOPPING',
          event: null
        };
        store.dispatch(playFullMedia(nullPlayer));
    };

    closeModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleBack();
    }

    showPurchaseSerieModal = (episode, pbi) => {
        const statusUser = store.getState().user.userStatus;
        const { showModal = () => {} } = this.props;
        const { is_series:isSerie, live_enabled, format_types, title: name, title_episode, id: groupId , proveedor_code, proveedor_name: providerName, episode_number, season_number} = episode;
        const isLive = live_enabled === '1';
        const category = getContentCategory(isLive, isSerie, []);
        const category2 =  DOES_NOT_APPLY;
        const category3= {episode: getContentAvailability(format_types, proveedor_code, isSerie, true),
        season: getContentAvailability(format_types, proveedor_code, isSerie, false)};
        const category4= {episode: getSeasonEpisodeInfo(isSerie, true ,{
            number: episode_number,
            season: season_number,
            name: title_episode,
        }), season : getSeasonEpisodeInfo(isSerie, false ,{
            number: episode_number,
            season: season_number,
            name: title_episode,
        })};

        const extraData = {groupId, name, category, category2, category3, category4, providerName}
        const propsModalPurchaseSerie = {
                pbi: {...pbi, groupId},
                serie:{
                    title: name,
                    episode: title_episode
                },
                extraData,
                endPlayer: () => {this.stop()},
                yellowAction: (e) => {this.closeModal(e)},
            }
        const propsModalKeepWatching = {
          history: this.props.history,
          groupId,
        }
        const modalProps = statusUser === 'anonymous' ? propsModalKeepWatching : propsModalPurchaseSerie;
        const validateTypeModal = statusUser === 'anonymous' ? MODAL_KEEP_WATCHING : MODAL_PURCHASE_SERIE;

        if(validateTypeModal === MODAL_KEEP_WATCHING) {
            let position = 0;
            const episodesInCarrusel = Array.from(document.querySelectorAll('.aaf-main-modal-options-episodes-main-container'));
            if(episodesInCarrusel) {
                const index = episodesInCarrusel.findIndex(ep => ep.id === `modal_episode_number_${episode_number}`)
                position = index === -1 ? 2 : index;
            }
            modalProps.dataAfterBack = {
                number: episode_number,
                season: season_number,
                position: position,
                groupId
            }
        }

        showModal({
            modalProps,
            modalType: validateTypeModal,
        });
    }

    showModalNotPurchasedEpisodeError = (error) => {
        /* El valor 'PLY_PLY_00007' podría cambiar en APA, por lo que es necesaria una mejor forma de obtener esa referencia, desde API por ejemplo */
        const code =
          error && error.errors && error.errors[0].code ? error.errors[0].code : 'PLY_PLY_00007';
        const errorMsg = Translator.get(code, '');
        const modalProps = {
          callback: null,
          content: { message: errorMsg }
        };
        const modal = {
          modalType: AAF_MODAL_ERROR,
          modalProps
        };
        this.props.showModal(modal);
    }

    sendMetric(label) {
        // Esta logica proviene de EpisodeSelection
        if (typeof this.props.setMetricsEvent === 'function' && window.location.toString().indexOf('vcard') !== -1
        ) {
          this.props.setMetricsEvent({
            hitType: 'event',
            eventCategory: 'vcard',
            eventAction: 'cambiar temporada',
            eventLabel: `${label} - ${this.props.title}`
          });
          this.props.setMetricsEvent({ type: 'executor' });
          this.sendDimension();
        }
    }

    sendDimension() {
        const payload = new AnalyticsDimensionSingleton().getPayload();
        this.props.setMetricsEvent(payload);
        this.props.setMetricsEvent({ type: 'executor' });
      }

      async getPBI (episodes) {
        let groupIds = [];
        if (this.isAnonymous()){
            this.setState({pbi: [], isBookmarkUpdateOrPBIUpdate: true});
        }
        if (episodes && Array.isArray(episodes)) {
            groupIds =  episodes.map(ep => {
                return ep.id || '';
            });
            if (groupIds && Array.isArray(groupIds)) {
                await api.getMultiplePBIS(groupIds).then(result => {
                    const { data: { listButtons = [] } = {} } = result;
                    this.setState({pbi: listButtons})
                }).catch(e => {
                    logger.debug('### [MultiplePBI]-error', e);
                    this.setState({pbi: []})
                })
            }
        }
    }

    getBookmark = async (seasons) => {
        let groupIds = [];
        if (this.isAnonymous()){
            this.setState({bookmark: [], isBookmarkUpdateOrPBIUpdate: true});
        }
        if(seasons && Array.isArray(seasons)){
            groupIds =  seasons.map(ep => {
                return ep.id || '';
            });
            if(groupIds && Array.isArray(groupIds)){
                groupIds = groupIds.join(',');
                await api.getBookmark(groupIds).then(bookmark =>{
                    const { response: { groups = [] } = {} } = bookmark;
                    this.setState({bookmark: groups, isBookmarkUpdateOrPBIUpdate: true})
                }).catch(e =>{
                    logger.debug('[Bookmar]-error', e);
                })
            }
        }
    };


    init = async () => {
        let {data:{episodeNumber = null,seasonNumber= null,seasons = []} = {}} = this.props;
        let episodes = [];
        if(this.props.dataAfterBack) {
            seasonNumber = this.props.dataAfterBack.season || seasonNumber;
            episodeNumber = this.props.dataAfterBack.number || episodeNumber;
        }
        if(seasons && Array.isArray(seasons)){
            const current_season = seasons.find((season) => season.number === seasonNumber);
            episodes = current_season && current_season.episodes || [];
        }
        this.setState({episodeNumber,seasonNumber,seasons, episodes, isBookmarkUpdateOrPBIUpdate: false}, async () =>{
            this.focus();
            await this.getBookmark(episodes);
            await this.getPBI(episodes);
        });
    };

    focus = () =>{
        if(this.props.dataAfterBack) {
            window.SpatialNavigation.focus(`#modal_episode_number_${parseInt(this.props.dataAfterBack.number) - 1}`)
        } else {
            window.SpatialNavigation.focus('.aaf-main-modal-options-button-seasons-current');
        }
    }

    changeSeason = async (season) =>{
        const {number = null, episodes = []}=season;
        number && this.setState({seasonNumber: number, episodes, isBookmarkUpdateOrPBIUpdate: false}, async ()=>{
            window.SpatialNavigation.focus('#modal_episode_number_0');
            season && season.number && this.sendMetric('Temporada ' + season.number);
            await this.getBookmark(episodes);
            await this.getPBI(episodes);
        });
    }

    handleBack = () => {
        this.props && (typeof this.props.handleClose ==='function') && this.props.handleClose();
    };

    repeatEpisodes(minEpisodes) {
        /* Se repiten cards cuando la cantidad de episodios es menor a los que se necesitan en el carrusel,
        para que el carrusel pueda funcionar bien de manera cíclica
        Los episodios no pueden tener exactamente la mismo info porque de ser así el foco no funciona bien
        Por eso se agrega el atributo repeated${index} a las cards repetidas, y de esta manera se genera un único idx_temp por card */
        let episodes = [...this.state.episodes];
        let episodesLength = episodes.length;
        let index = 1;

        while(episodesLength < minEpisodes) {
            episodes = [...episodes, ...this.state.episodes.map(ep => ({...ep, key: ep.id + '-index' + index}))];
            episodesLength += episodesLength;
            index++;
        }

        return episodes;
    }


    render() {
        let {episodeNumber = null,seasonNumber= null,seasons = [], episodes = [], bookmark = [], pbi = [], isBookmarkUpdateOrPBIUpdate = false} = this.state;

        episodes.map(ep => ({...ep, key: ep.id}))

        episodes = episodes.length === 0 ? episodes : this.repeatEpisodes(5);

        return (
            <div>
                <Row className={cls(`aaf-main-modal-episodes-wraper`)}>
                    <SeasonsNumber seasons={seasons} seasonNumber={seasonNumber} changeSeason={this.changeSeason}/>
                    <EpisodesList
                        episodeNumber={episodeNumber}
                        episodes={episodes}
                        group_id={this.props.group_id || null}
                        bookmark={bookmark}
                        onClick={this.onClick}
                        pbi={pbi}
                        dataAfterBack={this.props.dataAfterBack}
                        isBookmarkUpdateOrPBIUpdate={isBookmarkUpdateOrPBIUpdate}
                    />
                </Row>
                <Row>
                    <Column className={cls('aaf-main-modal-episodes-wraper-yellow-div')}>
                        <ColoredButton color="yellow" className={cls(`aaf-main-modal-episodes-yellow-button`, `focusable`)} onClick={this.handleBack}>{this.titleBack}</ColoredButton>
                    </Column>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user
});

const mapDispatchToProps = {
    setMetricsEvent,
    playFullMedia,
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(EpisodesManager);



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/EpisodesManager.jsx